
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="type-modal">
    <div class="card" [formGroup]="modalForm" style="padding-bottom: 12px;">
      <h3 class="green decoration mb-4">Editar usuario del comercio</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="modalForm.get('first_name').dirty && modalForm.get('first_name').invalid">
        <span>Nombres</span>
        <input type="text" formControlName="first_name" placeholder="Ingrese su nombre">
        <p *ngIf="modalForm.get('first_name').dirty && modalForm.get('first_name').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="modalForm.get('first_name').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="modalForm.get('last_name').dirty && modalForm.get('last_name').invalid">
        <span>Apellidos</span>
        <input type="text" formControlName="last_name" placeholder="Ingrese su nombre">
        <p *ngIf="modalForm.get('last_name').dirty && modalForm.get('last_name').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="modalForm.get('last_name').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="modalForm.get('email').dirty && modalForm.get('email').invalid">
        <span>Email</span>
        <input type="text" formControlName="email" placeholder="Ingrese su email">
        <p *ngIf="modalForm.get('email').dirty && modalForm.get('email').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="modalForm.get('email').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="modalForm.get('cellphone').dirty && modalForm.get('cellphone').invalid">
        <span>Número celular</span>
        <input type="number" formControlName="cellphone" placeholder="Ingrese su número celular">
        <p *ngIf="modalForm.get('cellphone').dirty && modalForm.get('cellphone').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="modalForm.get('cellphone').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex flex-wrap justify-between actions_modal gap-3">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big w-full md:w-fit">Cancelar</button>
        <div class="flex flex-wrap gap-2 w-full md:w-fit">
          <button mat-button type="button" (click)="resetPassword()" class="btn btn-gray w-full md:w-fit big">Recuperar contraseña</button>
          <button mat-button type="button" (click)="saveUser()" class="btn btn-primary w-full md:w-fit big !ml-0">Guardar</button>
        </div>
  </div>
</div>
